export const FIND_SHADE_BTN_ID = 'findMyShade';
export const SKU_IDS = 'skuIds';
export const FOUNDATION_FINDER_SHADE_MATCH = 'FoundationFinder_shadeMatch';
export const FOUNDATION_FINDER_QUIZ = 'FoundationFinder_quiz';
export const FOUNDATION_FINDER_SITE_NAV = 'FoundationFinder';
export const QUIZ_MATCHER = 'quiz-matcher';
export const TAKE_QUIZ_FLOW_COMPLETE = 'take_quiz_flow_complete';
export const MATCH_CURRENT_SHADE_FLOW_COMPLETE =
  'match_current_shade_flow_complete';
export const MATCH_CURRENT_SHADE_FLOW_INITIATED =
  'match_current_shade_flow_initiated';
export const TAKE_QUIZ_FLOW_INITIATED = 'take_quiz_flow_initiated';
export const FOUNDATION_FINDER_POPUP = 'FoundationFinder_popup';
export const BRAND_TO_BRAND_JOURNEY = 'brand-to-brand-journey-start';
